export default "__VITE_ASSET__BOACAqv___"